(()=>{'use strict';if(customElements.get('peptia-mobile-hero'))return;
function initScan(root,cleanups,signal){  'use strict';

  const stage = root.querySelector('.center-vial-stage');
  if (!stage) return;

  const vials = Array.from(stage.querySelectorAll('.scan-vial'));
  const line = stage.querySelector('.vial-scan-line');
  const hero = stage.closest('.app-hero, .hero, .immersive-hero, main') || stage.parentElement;
  const lightRoot = (hero && hero.querySelector('.center-vial-light')) ||
    root.querySelector('.center-vial-light');
  const lights = lightRoot ? Array.from(lightRoot.querySelectorAll('.scan-light')) : [];
  if (vials.length < 2 || !line) return;

  const products = ['slim', 'flow', 'reta', 'regen', 'epita', 'repair'];
  const angles = [0, 24, -24, 42, -42];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialDelay = 1600;
  const cycleDuration = 2200;
  const revealDuration = 420;
  const pulseDuration = 300;
  const animations = new Set();
  const fullClip='polygon(0% 0%,100% 0%,100% 100%,0% 100%)';
  const emptyClip='polygon(0% 0%,100% 0%,100% 0%,0% 0%)';
  let index = 0;
  let transitionNumber = 0;
  let epoch = 0;
  let ready = false;
  let inView = !('IntersectionObserver' in window);
  let transitioning = false;
  let timer = null;
  let dueAt = 0;
  let remainingDelay = initialDelay;

  const canRun = () => ready && inView && !document.hidden && !reduceMotion.matches && root.dataset.animate !== "false" && root.isConnected;
  const productName = position => vials[position].dataset.product || products[position] || String(position + 1);

  function setState() {
    stage.dataset.product = productName(index);
    stage.dataset.transitionCount = String(transitionNumber);
    stage.dataset.motionState = !ready ? 'loading' : reduceMotion.matches ? 'reduced-motion' :
      !inView || document.hidden ? 'paused' : transitioning ? 'transition' : 'steady';
  }

  function clearTimer(remember = false) {
    if (timer !== null) {
      if (remember) remainingDelay = Math.max(0, dueAt - performance.now());
      window.clearTimeout(timer);
      timer = null;
    }
  }

  function schedule(delay) {
    clearTimer();
    remainingDelay = delay;
    if (!canRun()) return;
    dueAt = performance.now() + delay;
    timer = window.setTimeout(() => {
      timer = null;
      beginTransition();
    }, delay);
  }

  function trackAnimation(element, frames, options) {
    const animation = element.animate(frames, options);
    animations.add(animation);
    if (!canRun()) animation.pause();
    return animation;
  }

  function forgetAnimations(list) {
    list.forEach(animation => {
      animations.delete(animation);
      animation.cancel();
    });
  }

  function resetSequence() {
    epoch += 1;
    clearTimer();
    animations.forEach(animation => animation.cancel());
    animations.clear();
    index = 0;
    transitionNumber = 0;
    transitioning = false;
    remainingDelay = initialDelay;
    delete stage.dataset.nextProduct;
    delete stage.dataset.scanAngle;
    vials.forEach((vial, position) => {
      vial.style.visibility = 'visible';
      vial.style.opacity = '1';
      vial.style.clipPath = position === 0 ? fullClip : emptyClip;
      vial.style.zIndex = String(position + 1);
      const image = vial instanceof HTMLImageElement ? vial : vial.querySelector('img');
      if (image) { image.style.transform = 'translateY(0) scale(1)'; image.style.transformOrigin = '50% 50%'; }
    });
    lights.forEach((light, position) => { light.style.opacity = position === 0 ? '1' : '0'; });
    line.style.opacity = '0';
    setState();
  }

  function revealGeometry(vial, degrees) {
    const stageBox = stage.getBoundingClientRect();
    const vialBox = vial.getBoundingClientRect();
    const width = stage.clientWidth || 82;
    const height = stage.clientHeight || 98;
    const scaleX = stageBox.width / width || 1;
    const scaleY = stageBox.height / height || 1;
    const vialLeft = (vialBox.left - stageBox.left) / scaleX;
    const vialTop = (vialBox.top - stageBox.top) / scaleY;
    const vialWidth = vialBox.width / scaleX || width;
    const vialHeight = vialBox.height / scaleY || height;
    const slope = Math.tan(degrees * Math.PI / 180);
    const margin = Math.abs(slope) * width / 2 + 8;
    const start = -margin;
    const end = height + margin;
    const lineWidth = Math.ceil(Math.hypot(width, height) * 1.6);
    const top = -Math.max(200, (height + margin * 2) / vialHeight * 100);

    const edgeAt = centerY => {
      const leftY = (centerY + slope * (vialLeft - width / 2) - vialTop) / vialHeight * 100;
      const rightY = (centerY + slope * (vialLeft + vialWidth - width / 2) - vialTop) / vialHeight * 100;
      return { leftY, rightY };
    };
    const polygon = centerY => {
      const { leftY, rightY } = edgeAt(centerY);
      return `polygon(0% ${top}%,100% ${top}%,100% ${rightY}%,0% ${leftY}%)`;
    };
    const complementaryPolygon = centerY => {
      const { leftY, rightY } = edgeAt(centerY - .75);
      const bottom = 100 - top;
      return `polygon(0% ${leftY}%,100% ${rightY}%,100% ${bottom}%,0% ${bottom}%)`;
    };
    const transform = y => `translate3d(${-lineWidth / 2}px,${y}px,0) rotate(${degrees}deg)`;
    return { start, end, polygon, complementaryPolygon, transform, lineWidth };
  }

  async function beginTransition() {
    if (!canRun() || transitioning) return;
    const currentEpoch = epoch;
    const next = (index + 1) % vials.length;
    const previousVial = vials[index];
    const nextVial = vials[next];
    const angle = angles[transitionNumber % angles.length];
    const geometry = revealGeometry(nextVial, angle);
    const previousGeometry = revealGeometry(previousVial, angle);
    const localAnimations = [];
    transitioning = true;
    stage.dataset.nextProduct = productName(next);
    stage.dataset.scanAngle = String(angle);
    setState();

    nextVial.style.clipPath = geometry.polygon(geometry.start);
    previousVial.style.clipPath = previousGeometry.complementaryPolygon(geometry.start);
    line.style.position = 'absolute';
    line.style.left = '50%';
    line.style.top = '0';
    line.style.width = `${geometry.lineWidth}px`;
    line.style.height = '1px';
    line.style.background = 'linear-gradient(to right,transparent,rgba(78,105,114,.25) 22%,rgba(255,255,255,.9) 48%,rgba(78,105,114,.25) 78%,transparent)';
    line.style.transformOrigin = '50% 50%';
    line.style.zIndex = '8';
    const productColor=lights[next] ? getComputedStyle(lights[next]).getPropertyValue('--vial-light-color').trim() : '197 212 215';
    line.style.background=`linear-gradient(to right,transparent,rgb(${productColor} / .7) 24%,rgb(255 255 255 / .9) 50%,rgb(${productColor} / .7) 76%,transparent)`;
    const timing = { duration: revealDuration, easing: 'cubic-bezier(.45,0,.25,1)', fill: 'both' };

    localAnimations.push(trackAnimation(nextVial, [
      { clipPath: geometry.polygon(geometry.start) },
      { clipPath: geometry.polygon(geometry.end) }
    ], timing));
    localAnimations.push(trackAnimation(previousVial, [
      { clipPath: previousGeometry.complementaryPolygon(geometry.start) },
      { clipPath: previousGeometry.complementaryPolygon(geometry.end) }
    ], timing));
    localAnimations.push(trackAnimation(line, [
      { transform: geometry.transform(geometry.start), opacity: 0, offset: 0 },
      { transform: geometry.transform(geometry.start + (geometry.end - geometry.start) * .12), opacity: .5, offset: .12 },
      { transform: geometry.transform(geometry.start + (geometry.end - geometry.start) * .88), opacity: .5, offset: .88 },
      { transform: geometry.transform(geometry.end), opacity: 0, offset: 1 }
    ], timing));
    // A crisp forward bounce belongs to the images; wrapper masks stay fixed, without blur.
    [previousVial, nextVial].forEach(vial => {
      const image = vial instanceof HTMLImageElement ? vial : vial.querySelector('img');
      if (!image) return;
      localAnimations.push(trackAnimation(image, [
        { transform: 'translateY(0) scale(1)', offset: 0, easing: 'ease-out' },
        { transform: 'translateY(-1px) scale(1.065)', offset: .38, easing: 'ease-in-out' },
        { transform: 'translateY(-.06px) scale(1.004)', offset: .74, easing: 'ease-out' },
        { transform: 'translateY(0) scale(1)', offset: 1 }
      ], { duration: pulseDuration, easing: 'linear', fill: 'both' }));
    });
    if (lights[index]) localAnimations.push(trackAnimation(lights[index], [{ opacity: 1 }, { opacity: 0 }], timing));
    if (lights[next]) localAnimations.push(trackAnimation(lights[next], [{ opacity: 0 }, { opacity: 1 }], timing));

    try {
      await Promise.all(localAnimations.map(animation => animation.finished));
    } catch (_) {
      return;
    }
    if (currentEpoch !== epoch) return;
    // Preserve the same final polygons before releasing WAAPI. No none/visibility toggle.
    previousVial.style.clipPath = previousGeometry.complementaryPolygon(geometry.end);
    nextVial.style.clipPath = geometry.polygon(geometry.end);
    lights.forEach((light, position) => { light.style.opacity = position === next ? '1' : '0'; });
    line.style.opacity = '0';
    // Commit the exact resting transform before cancelling the filled animation.
    // The return never dips below scale 1, so it cannot widen again at its tail.
    [previousVial, nextVial].forEach(vial => {
      const image = vial instanceof HTMLImageElement ? vial : vial.querySelector('img');
      if (image) image.style.transform = 'translateY(0) scale(1)';
    });
    forgetAnimations(localAnimations);
    index = next;
    transitionNumber += 1;
    transitioning = false;
    delete stage.dataset.nextProduct;
    setState();
    schedule(cycleDuration - revealDuration);
  }

  function syncPlayback() {
    if (canRun()) {
      animations.forEach(animation => { if (animation.playState === 'paused') animation.play(); });
      if (!transitioning && timer === null) schedule(remainingDelay);
    } else {
      clearTimer(true);
      animations.forEach(animation => { if (animation.playState === 'running') animation.pause(); });
    }
    setState();
  }

  document.addEventListener('visibilitychange', syncPlayback, {signal});
  reduceMotion.addEventListener('change', () => { resetSequence(); syncPlayback(); }, {signal});
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio > 0);
      syncPlayback();
    }, { threshold: 0 });
    observer.observe(hero || stage);
    cleanups.push(() => observer.disconnect());
  }

  resetSequence();
  Promise.all(vials.map(vial => {
    const image = vial instanceof HTMLImageElement ? vial : vial.querySelector('img');
    if (!image) return Promise.resolve();
    if (typeof image.decode === 'function') return image.decode().catch(() => {});
    if (image.complete) return Promise.resolve();
    return new Promise(resolve => {
      image.addEventListener('load', resolve, { once: true });
      image.addEventListener('error', resolve, { once: true });
    });
  })).then(() => {
    ready = true;
    syncPlayback();
  });

 cleanups.push(() => { epoch++; clearTimer(); animations.forEach(a=>a.cancel()); animations.clear(); });
}
function initDepth(root,cleanups,signal){ const hero=root.querySelector('.app-hero'),stage=root.querySelector('.vial-focus-stage');
 const slots=[...stage.querySelectorAll('.focus-vial')],lights=[...root.querySelectorAll('.vial-light')],reduced=matchMedia('(prefers-reduced-motion: reduce)');
 let animations=[],intersects=false,ready=false,raf=0,last=0;
 const grain=root.classList.contains('effect-grain');
 const alphaNodes=slots.map(s=>s.dataset.alpha?root.querySelector('#'+s.dataset.alpha):null);
 function reveal(p){if(p<=.22)return 1;if(p<.4)return 1-(p-.22)/.18;if(p<.74)return 0;return (p-.74)/.26;}
 function tick(time){if(time-last>34){last=time;animations.forEach((a,i)=>{const p=(((Number(a.currentTime)||0)+i*4000)%8000)/8000;alphaNodes[i]?.setAttribute('intercept',(-6+7*reveal(p)).toFixed(3));});}raf=requestAnimationFrame(tick);}
 function sync(){if(!ready)return;const active=intersects&&!document.hidden&&!reduced.matches && root.dataset.animate !== "false" && root.isConnected;animations=slots.map(s=>s.getAnimations()[0]).filter(Boolean);const lightAnimations=lights.map(s=>s.getAnimations()[0]).filter(Boolean);[...animations,...lightAnimations].forEach(a=>active?a.play():a.pause());stage.dataset.motionState=active?'running':'paused';stage.dataset.animationCount=String(animations.length);if(raf){cancelAnimationFrame(raf);raf=0}if(active&&grain)raf=requestAnimationFrame(tick);}
 const observer=new IntersectionObserver(entries=>{intersects=entries[0].isIntersecting;sync()},{threshold:.03});observer.observe(hero);cleanups.push(()=>observer.disconnect());
 document.addEventListener('visibilitychange',sync,{signal});reduced.addEventListener('change',sync,{signal});
 Promise.all(slots.map(s=>s.querySelector('img').decode())).then(()=>{root.classList.add('fx-ready');animations=slots.map(s=>s.getAnimations()[0]).filter(Boolean);ready=true;sync();}).catch(()=>{slots[0].style.opacity='1'});

 cleanups.push(()=>{ready=false;cancelAnimationFrame(raf);animations.forEach(a=>a.cancel())});
}
class PeptiaMobileHero extends HTMLElement {
 connectedCallback(){this.cleanups=[];this.controller=new AbortController();this.frame=requestAnimationFrame(()=>this.start());}
 start(){if(!this.isConnected)return;const signal=this.controller.signal;
 const syncHeader=()=>document.documentElement.toggleAttribute('data-peptia-hero-scrolled',window.scrollY>4);window.addEventListener('scroll',syncHeader,{passive:true,signal});syncHeader();this.cleanups.push(()=>document.documentElement.removeAttribute('data-peptia-hero-scrolled')); 
  if(this.querySelector('.center-vial-stage'))initScan(this,this.cleanups,signal);
  if(this.querySelector('.vial-focus-stage'))initDepth(this,this.cleanups,signal);
  const syncPills=()=>this.toggleAttribute('data-paused',!this.inView||document.hidden||this.dataset.animate==='false');
  const observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;syncPills()},{threshold:0});observer.observe(this);this.cleanups.push(()=>observer.disconnect());
  document.addEventListener('visibilitychange',syncPills,{signal});syncPills();
 }
 disconnectedCallback(){cancelAnimationFrame(this.frame);this.controller?.abort();this.cleanups?.forEach(fn=>fn());}
}
customElements.define('peptia-mobile-hero',PeptiaMobileHero);
})();
